<template>
  <div class="cardManage">
    <van-tabs v-model="active" color="#C39C71" line-width="40" class="tabs">
      <van-tab title="手机号">
        <van-search
          v-model="searchMoblieNo"
          label="手机号"
          shape="round"
          placeholder="请输入搜索手机号"
          clearable
          maxlength="11"
          show-action
          type="number"
          @search="searchCardByMobile"
        >
          <template #action>
            <div @click="searchCardByMobile">查询</div>
          </template>
        </van-search>
        <van-divider dashed />

        <!-- 储值卡列表 -->
        <div class="card-list">
          <div
            v-on:click="toCardDetail(item)"
            v-for="(item, idx) in cardList"
            v-bind:key="idx"
            class="card"
          >
            <div class="card-no">{{ item.prepaidCardCode }}</div>
            <div class="card-title">{{ item.categoryName }}</div>
            <div class="card-amount">可用余额 ￥{{ item.surplusMoney }}</div>
          </div>
        </div>
        <!-- </template> -->
        <van-divider
          v-if="hasMember"
          dashed
          :style="{ borderColor: '#C39C71', padding: '0 16px' }"
        />
        <div
          class="addCard"
          v-if="hasMember"
          v-on:click="chanageShowAddCardDialog(1)"
        >
          <van-icon name="plus" /> 绑定储值卡
        </div>
        <van-divider
          v-if="hasMember"
          dashed
          :style="{ borderColor: '#C39C71', padding: '0 16px' }"
        />
        <van-empty
          :style="{ display: isMobileEmpty ? '' : 'none' }"
          description="该手机未查询到储值卡！"
        >
          <div :style="{ display: hasMember ? 'none' : 'block' }">
            <van-button plain type="default" to="registerMember"
              >立即注册</van-button
            >
          </div>
        </van-empty>
      </van-tab>
      <van-tab title="储值卡号">
        <van-search
          v-model="searchCardNo"
          label="储值卡号"
          shape="round"
          placeholder="请输入搜索储值卡号"
          clearable
          show-action
          @search="searchCardByCard"
        >
          <template #action>
            <div @click="searchCardByCard">查询</div>
          </template>
        </van-search>
        <!-- 储值卡列表 -->
        <div
          class="card"
          v-on:click="toCardDetail(item)"
          v-for="(item, idx) in cardList2"
          v-bind:key="idx"
        >
          <div class="card-no">{{ item.prepaidCardCode }}</div>
          <div class="card-title">{{ item.sgMemo }}</div>
          <div class="disable" v-if="item.tel == '' || item.tel == null">
            <div v-on:click="chanageShowAddCardDialog(2)">
              绑定手机并注册会员
            </div>
          </div>

          <div class="card-amount">可用余额 ￥{{ item.surplusMoney }}</div>
        </div>
        <van-empty
          :style="{ display: isCardEmpty ? '' : 'none' }"
          description="储值卡不存在！"
        >
        </van-empty>
      </van-tab>
    </van-tabs>
    <van-dialog
      title="绑定储值卡"
      class="addCard-dialog"
      v-model="showAddCardDialog"
      :show-confirm-button="false"
      :showCancelButton="true"
    >
      <van-cell-group>
        <van-form validate-first @failed="onFailed" @submit="doBindValueCard">
          <van-field
            v-model="newCard.userName"
            label="姓名:"
            :readonly="type == 1"
            placeholder="请输入用户名"
          />
          <van-field
            v-model="newCard.phone"
            label="手机号码:"
            :readonly="type == 1"
            placeholder="请输入用户名"
          />
          <van-field
            v-model="newCard.cardNumber"
            :readonly="type == 2"
            label="储值卡号:"
            placeholder="请输入储值卡号"
          />
          <van-field
            v-model="newCard.pwd"
            label="储值卡密码:"
            type="password"
            placeholder="请输入储值卡密码"
          />
          <van-field
            v-model="newCard.yzm"
            label="验证码:"
            placeholder="请输入验证码"
          >
            <div slot="button">
              <div v-if="showCountDown">
                <van-count-down
                  :time="smsTime"
                  format="ss"
                  @finish="countDownFinish"
                />
              </div>
              <div v-else class="smsCodeText" v-on:click="sendSmsCode">
                获取验证码
              </div>
            </div>
          </van-field>
          <!-- 登陆按钮 -->
          <div class="btn-wrap" style="margin-top: 16px">
            <van-button round block type="info" class="btn" native-type="submit"
              >提交</van-button
            >
          </div>
        </van-form>
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import "../../assets/css/cardManage.less";
import { bindValueCard } from "@/api/card";
import { queryGet } from "@/api/common";
import { sendSmsCode } from "@/api/user";

export default {
  name: "CardManage",
  data() {
    return {
      searchMoblieNo: "", //搜索的手机号
      searchMoblieNoError: "",
      searchCardNo: "", //搜索的储值卡号
      searchCardNoError: "",

      isMobileEmpty: false, //手机号搜索为空
      isCardEmpty: false, //卡号搜索为空
      hasMember: false, //会员不存在
      hasBindCard: false, //没有绑定过储值卡
      hasCard: false, //卡号不存在
      active: "",

      cardList: [],
      cardList2: [],
      showAddCardDialog: false, //是否显示添加储值卡
      type: "",
      newCard: {
        userName: "",
        phone: "",
        cardNumber: "",
        pwd: "",
        yzm: "",
      },
      userName: "",
      smsCode: "",
      smsTime: 60 * 1000,
      showCountDown: false, //是否显示倒计时
    };
  },
  components: {},
  created() {
    this.loadComments();
  },
  methods: {
    loadComments() {
      // debugger
      let s = sessionStorage.getItem("shopInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
    },

    chanageShowAddCardDialog(type) {
      this.type = type;
      if (type == 1) {
        //按手机号绑定储值卡
        this.newCard.cardNumber = "";
        this.newCard.phone = this.searchMoblieNo;
        this.newCard.userName = this.userName;
      } else {
        //按储值卡号绑定手机
        this.newCard.userName = "";
        this.newCard.phone = "";
        this.newCard.cardNumber = this.searchCardNo;
      }
      this.showAddCardDialog = !this.showAddCardDialog;
    },
    //根据手机号查询储储值卡
    searchCardByMobile() {
      const _this = this;
      if (!/^1[3456789]\d{9}$/.test(_this.searchMoblieNo)) {
        _this.$toast.fail("手机号码有误，请重填");
        return false;
      }
      let params = {
        phone: _this.searchMoblieNo,
        shopCode: _this.shopInfo.shopCode,
      };
      let url = "/api/mbrinfo/getStoredValueCard";
      queryGet(url, params)
        .then((resp) => {
          let _data = resp.data;
          let _code = _data.code;
          _this.cardList = [];
          if (_code == "3002") {
            //未注册会员
            _this.isMobileEmpty = true;
            _this.hasMember = false;
          } else if (_code == "3005") {
            //没有储值卡
            _this.isMobileEmpty = true;
            _this.hasMember = true;
          } else if (_code == "0000") {
            let _result = _data.data.results;
            //存储绑定新卡所需要的数据
            if (!_result.mbrInfo) {
              _this.isMobileEmpty = true;
              _this.hasMember = false;
              return;
            }
            _this.hasMember = true;
            let card = _result.valueCardQueryVo;
            if (card == null || card == "") {
              //没有储值卡
              _this.isMobileEmpty = true;
              return;
            }
            _this.cardList = _result.valueCardQueryVo.valueCardVosl;
            _this.isMobileEmpty = false;
          } else {
            _this.hasMember = false;
            _this.$toast.fail(_data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searchCardByCard() {
      const _this = this;
      if (!/^[0-9a-zA-Z]+$/.test(_this.searchCardNo)) {
        _this.$toast.fail("卡号输入有误，请重填");
        return false;
      }
      let params = {
        valueCard: _this.searchCardNo,
        shopCode: _this.shopInfo.shopCode,
      };
      let url = "/api/mbrinfo/getStoredValueCardByValueCard";
      queryGet(url, params)
        .then((resp) => {
          let _data = resp.data;
          let _code = _data.code;
          _this.cardList2 = [];
          if (_code == "3005") {
            _this.isCardEmpty = true;
          } else if (_code == "0000") {
            let _result = _data.data;
            // //存储绑定新卡所需要的数据
            _this.cardList2 = _result.results.valueCardVosl;
            if (_this.cardList2 == null || _this.cardList2.length == 0) {
              _this.isCardEmpty = true;
            } else {
              _this.isCardEmpty = false;
            }
          } else {
            _this.$toast.fail(_data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //发送短信验证码
    sendSmsCode() {
      let _this = this;
      sendSmsCode(_this.newCard.phone, 1);
      _this.showCountDown = true;
      sessionStorage.setItem("sendTime", new Date().getTime());
    },

    //改变计时状态
    countDownFinish() {
      this.showCountDown = false;
    },
    onFailed() {},
    //绑定储值卡
    doBindValueCard() {
      let _this = this;
      let cardInfo = {
        cardNumber: _this.newCard.cardNumber,
        phone: _this.newCard.phone,
        pwd: _this.newCard.pwd,
        yzm: _this.newCard.yzm,
      };
      bindValueCard(cardInfo)
        .then((resp) => {
          let _data = resp.data;
          if (_data.code == "30000") {
            _this.showAddCardDialog = false;
            _this.cardList2 = [];
            _this.$toast.success(_data.msg);
          } else {
            _this.$toast.fail(_data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //跳转到卡详情页面
    toCardDetail(card) {
      sessionStorage.setItem("cardInfo", JSON.stringify(card));
      if (card.tel != null && card.tel != "") {
        this.$router.push("cardDetail");
      }
    },
  },
};
</script>


